import { Modal, Rate } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import { setModalState } from "../../store/reducers/Modal/actions";
import { MdCheckCircle } from "@react-icons/all-files/md/MdCheckCircle";
import { FaFileAlt } from "@react-icons/all-files/fa/FaFileAlt";
import { FaFileContract } from "@react-icons/all-files/fa/FaFileContract";
import { AiOutlineFileSearch } from "@react-icons/all-files/ai/AiOutlineFileSearch";
import { useLocation } from "react-router-dom";

import Button from "../../components/forms/Button";
import { useEffect, useState } from "react";

import { GOOGLE_ADS_ACCOUNT_ID, GOOGLE_ADS_CONVERSION_PURCHASE, reportEvent, reportGoogleConversion, reportScreen, setUserProperty } from "../../services/analyticsService";
import { PLANS } from "../../pages/ResumeBuilder/Components/PurchaseModal/constants";


const getPlanLabel = (planId) => {
    if (!planId) return '';
    const plan = PLANS.find(p => p.id === planId);
    return plan ? plan.label : 'Monthly';
};
export default props => {
    const { isSubscriptionSuccessModalOpen } = useSelector(({ ModalReducer }) => ModalReducer);
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const dispatch = useDispatch();
    const location = useLocation();
    const [visible, setVisible] = useState(false)

    const { planId } = userDetails?.subscription || {}

    useEffect(() => {

        // Check if we're on the thank you page and open the modal
        if (userDetails && location.search.includes('success=true')) {

            dispatch(setModalState('isSubscriptionSuccessModalOpen', true));
            setTimeout(() => {
                setVisible(true)
            }, 3000)
            reportGoogleConversion({
                sendTo: `${GOOGLE_ADS_ACCOUNT_ID}/${GOOGLE_ADS_CONVERSION_PURCHASE}`,
                transactionId: userDetails?._id,
                value: userDetails?.subscription?.totalCharged ? (userDetails?.subscription?.totalCharged / 100) : 1
            })
            setUserProperty(userDetails, 'paid', true)
        }
    }, [location.pathname, dispatch, userDetails]);

    useEffect(() => {
        if (isSubscriptionSuccessModalOpen && userDetails) {
            reportScreen('orderThankYou')
            reportEvent('order', 'thankYouLoad', {
                transactionId: userDetails._id,
                value: userDetails.subscription?.totalCharged ? (userDetails.subscription.totalCharged / 100) : 1
            })
            reportGoogleConversion({

                sendTo: 'AW-16890086783/RcD0COO21LkaEP-K6fU-',
                transactionId: userDetails._id,
                value: userDetails.subscription?.totalCharged ? (userDetails.subscription.totalCharged / 100) : 1
            })
        }
    }, [userDetails, isSubscriptionSuccessModalOpen])

    useEffect(() => {
        // Any initialization logic when modal opens
    }, [isSubscriptionSuccessModalOpen]);

    const onClose = () => {
        dispatch(setModalState('isSubscriptionSuccessModalOpen', false));
    };

    const onStartNow = () => {
        // Redirect to dashboard or job search page
        dispatch(setModalState('isSubscriptionSuccessModalOpen', false));
        window.location.href = "/";
    };
    return (
        <Modal className="subscription-success-modal"
            onCancel={() => onClose()} loading={!visible}
            open={isSubscriptionSuccessModalOpen}
            footer={null}>
            <div className="success-icon">
                <MdCheckCircle style={{ fontSize: 60, color: "#4CAF50" }} />
            </div>
            <div className="title">Payment Succeeded 🎉</div>
            <div className="subtitle">Congratulations! Your monthly subscription credits are now active. Start creating job-winning cover letters and resumes immediately. New credits will automatically refresh each month. Ready to land your dream job?</div>

            <div className="inner-card">
                <div className="subscription-details">
                    <div className="detail-item">
                        <span className="label">Plan:</span>
                        <span className="value">{getPlanLabel(planId) ? `${getPlanLabel(planId)}` : 'Monthly Subscription'}</span>
                    </div>
                    <div className="detail-item">
                        <span className="label">Status:</span>
                        <span className="value status-active">Active</span>
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 30 }}>
                    <Button
                        className="start-btn"
                        onClick={onStartNow}
                        style={{ width: "100%", marginTop: "20px", height: "48px", fontSize: "16px" }}>
                        Start Now
                    </Button>
                </div>
            </div>

            <div className="testimonial">
                <Rate value={5} disabled />
                <div className="text">"Get In Genie helped me make progress in 2 days that I haven't made in six months and I finally got my first job as a data analyst."</div>
                <div className="author">Max W. / Junior Data Analyst</div>
            </div>
        </Modal>
    );
}